import { render, staticRenderFns } from "./text-strikethrough.vue?vue&type=template&id=f6ed94ae&scoped=true&"
var script = {}
import style0 from "./text-strikethrough.vue?vue&type=style&index=0&id=f6ed94ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ed94ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6ed94ae')) {
      api.createRecord('f6ed94ae', component.options)
    } else {
      api.reload('f6ed94ae', component.options)
    }
    module.hot.accept("./text-strikethrough.vue?vue&type=template&id=f6ed94ae&scoped=true&", function () {
      api.rerender('f6ed94ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/other/cssfx/components/text-strikethrough.vue"
export default component.exports